import { createSlice } from '@reduxjs/toolkit';
import { emptyModel, initialState } from './initialState';
import { resetAllStores, resetPlanScopedStores } from '../sharedActions';
import {
  getBeneficiarios,
  getDadosCardInicial,
  getDIB,
  getPatrocinadora,
  getPerfilInvestimento,
} from './thunks';

const planSlice = createSlice({
  name: 'plan',
  initialState,
  reducers: {
    resetPlan: (state) => {
      state.DIB = initialState.DIB;
      state.beneficiarios = initialState.beneficiarios;
      state.patrocinadora = initialState.patrocinadora;
      state.perfilInvestimento = initialState.perfilInvestimento;
      state.rentabilidade = initialState.rentabilidade;
      state.saudeFinanceira = initialState.saudeFinanceira;
      state.simulacaoBeneficio = initialState.simulacaoBeneficio;
    },
    setSimulacaoRenda: (state, { payload }) => {
      state.simulacaoBeneficio = {
        ...state.simulacaoBeneficio,
        ...payload,
      };
    },
    setSimulacaoCard: (state, { payload }) => {
      state.simulacaoBeneficio = {
        ...state.simulacaoBeneficio,
        ...payload,
        tipoRendaMensal: payload.tipoRendaMensal,
      };
    },
    setSimulacaoBeneficiarios: (state, { payload }) => {
      state.simulacaoBeneficio.beneficiariosChecked = payload;
    },
    resetSimulacaoRenda: (state) => {
      state.simulacaoBeneficio = initialState.simulacaoBeneficio;
    },
  },

  extraReducers(builder) {
    builder.addCase(resetAllStores, () => initialState);
    builder.addCase(resetPlanScopedStores, () => initialState);

    builder.addCase(getPatrocinadora.pending, (state) => {
      state.patrocinadora.loading = true;
    });

    builder.addCase(getPatrocinadora.fulfilled, (state, action) => {
      state.patrocinadora = {
        data: action.payload,
        error: false,
        loading: false,
      };
    });

    builder.addCase(getPatrocinadora.rejected, (state) => {
      state.patrocinadora = { data: '', error: true, loading: false };
    });

    builder.addCase(getBeneficiarios.pending, (state) => {
      state.beneficiarios.loading = true;
    });

    builder.addCase(getBeneficiarios.fulfilled, (state, action) => {
      state.beneficiarios = {
        data: action.payload,
        error: false,
        loading: false,
        done: true,
      };
    });

    builder.addCase(getBeneficiarios.rejected, (state) => {
      state.beneficiarios = {
        data: [],
        error: true,
        loading: false,
        done: true,
      };
    });

    builder.addCase(getPerfilInvestimento.pending, (state) => {
      state.perfilInvestimento.loading = true;
    });

    builder.addCase(getPerfilInvestimento.fulfilled, (state, action) => {
      state.perfilInvestimento = {
        data: action.payload,
        error: false,
        loading: false,
      };
    });

    builder.addCase(getPerfilInvestimento.rejected, (state) => {
      state.perfilInvestimento = {
        data: { Label: '', Value: '' },
        error: true,
        loading: false,
      };
    });

    builder.addCase(getDIB.pending, (state) => {
      state.DIB.loading = true;
    });

    builder.addCase(getDIB.fulfilled, (state, action) => {
      state.DIB = { data: action.payload, error: false, loading: false };
    });

    builder.addCase(getDIB.rejected, (state) => {
      state.DIB = { data: '01/11/1997', error: true, loading: false };
    });

    builder.addCase(getDadosCardInicial.pending, (state) => {
      state.rentabilidade.loading = true;
      state.saudeFinanceira.loading = true;
    });

    builder.addCase(getDadosCardInicial.fulfilled, (state, action) => {
      state.rentabilidade = {
        data: action.payload.dadosRentabilidade,
        error: false,
        loading: false,
        done: true,
      };

      if (action.payload.saudeFinanceira.exaurimento.msgConsistencia !== '') {
        state.saudeFinanceira = {
          data: action.payload.saudeFinanceira,
          error: true,
          loading: false,
          done: true,
        };
      } else {
        state.saudeFinanceira = {
          data: action.payload.saudeFinanceira,
          error: false,
          loading: false,
          done: true,
        };
      }
    });

    builder.addCase(getDadosCardInicial.rejected, (state) => {
      const defaultExtrato = {
        ContaAdicional: { Contas: emptyModel },
        ContaIndividual: { Contas: emptyModel },
        ContaPatronal: { Contas: emptyModel },
      };

      state.rentabilidade = {
        data: {
          ...defaultExtrato,
          Saldo: 0,
          Rentabilidade: [],
          ultimaRentabilidade: { Percentual: 0, MesVigente: '' },
        },
        error: true,
        loading: false,
        done: true,
      };

      state.saudeFinanceira = {
        data: {},
        error: true,
        loading: false,
        done: true,
      };
    });
  },
});

export const plan = planSlice.reducer;
export const {
  resetPlan,
  setSimulacaoRenda,
  setSimulacaoCard,
  setSimulacaoBeneficiarios,
  resetSimulacaoRenda,
} = planSlice.actions;
